import React, { useState } from 'react';
import { Button } from '@mui/material';

export default function BillQuantity({ item, onChange }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');

  const commit = () => {
    const quantity = Number(draft);
    if (/^\d+$/.test(draft) && Number.isSafeInteger(quantity) && quantity > 0) {
      onChange(quantity);
    }
    setEditing(false);
  };

  if (editing) {
    return <input
      autoFocus
      aria-label={`Quantity for ${item.name}`}
      inputMode="numeric"
      value={draft}
      onFocus={event => event.target.select()}
      onChange={event => setDraft(event.target.value)}
      onBlur={commit}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.currentTarget.blur();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          setEditing(false);
        }
      }}
      style={{ width: 60, textAlign: 'center', fontSize: 18, fontWeight: 'bold' }}
    />;
  }

  return <Button
    aria-label={`Edit quantity for ${item.name}`}
    onClick={() => { setDraft(String(item.qty)); setEditing(true); }}
    sx={{ minWidth: 36, fontWeight: 'bold', fontSize: 18, color: 'var(--brand-primary)' }}>
    {item.qty}
  </Button>;
}
